// extracted by mini-css-extract-plugin
module.exports = {"component":"html-block_component__Kdj_i","component__content":"html-block_component__content__u0N_n"};